import { render, staticRenderFns } from "./BulkInvitation.vue?vue&type=template&id=511ed909&scoped=true&"
import script from "./BulkInvitation.vue?vue&type=script&lang=js&"
export * from "./BulkInvitation.vue?vue&type=script&lang=js&"
import style0 from "./BulkInvitation.vue?vue&type=style&index=0&id=511ed909&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ed909",
  null
  
)

export default component.exports